import React from 'react';
import GroupIcon from '../../../img/icons/group-pink2.svg';
import FullLogo from '../../../img/energyaid.png';

class Header extends React.Component {
	render() {
		const { parent, user, group, school, project } = this.props;

		return (
			<div
				className="student-header"
				style={{
					backgroundImage: project.sales_image ? 'url('+project.sales_image+')' : ''
				}}
			>
				<div className="student-header-top">
					<div className="container">
						<div className="content">
							<div className="student-header-left">
									<span className="student-icon group">
										<img src={ GroupIcon } alt="Ikon" />
									</span>

								<div style={{ float: 'left' }}>
									<div className="student-name">{ user.first_name }</div>
									<div>{ group.name +' '+ school.name }</div>
								</div>
							</div>

							<div className="student-header-right">
								<img src={ FullLogo } alt="EnergyAid" />
							</div>
						</div>
					</div>
				</div>

				<div className="student-header-title">
					<div className="container">
						<div className="content" style={{ marginBottom: '-46px', position: 'relative', zIndex: '10' }}>
							<h3>Vår insamling</h3>
							<h1>{ project.sales_title ? project.sales_title : project.title }</h1>

							{ (project && project.sales_description) &&
								<span style={{ cursor: 'pointer' }} onClick={ () => parent.setState({ page: 'about' })}>Läs mer</span>
							}
						</div>
					</div>
				</div>

				<div style={{ float: 'left', width: '100%', overflow: 'hidden' }}>
					<svg style={{ float: 'left', width: '100%', margin: '-1px 0' }} width="100%" viewBox="0 0 592 80" version="1.1" xmlns="http://www.w3.org/2000/svg">
						<defs>
							<rect id="path-1" x="0.00920172613" y="0" width="592" height="80"/>
						</defs>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<g id="Group" transform="translate(-0.009202, 0.000000)">
								<mask id="mask-2" fill="white">
									<use xlinkHref="#path-1"/>
								</mask>
								<use id="Rectangle" fill="#50254A" xlinkHref="#path-1"/>
								<path d="M0.00920172613,0.111264678 L592.009202,0.111264678 C530.750087,45.6373486 432.083371,68.4003906 296.009054,68.4003906 C159.934738,68.4003906 61.26812,45.6373486 0.00920172613,0.111264678 Z" id="Rectangle" fill="#F5326E" mask="url(#mask-2)"/>
								<path d="M592.018109,0.111396338 L592.013457,11.0551527 C501.436509,50.8883727 401.305079,73 296.009202,73 C190.713361,73 90.5819647,50.8883882 0.00504170794,11.0551947 L-8.52651283e-14,0.111264678 C90.4017823,40.5274814 190.581123,63 296.009202,63 C401.437166,63 501.616404,40.5275302 592.018109,0.111396338 Z" id="Combined-Shape" fill="#FFFFFF" fillRule="nonzero" mask="url(#mask-2)"/>
							</g>
						</g>
					</svg>
				</div>
			</div>
		)
	}
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/Header.js